import './context.css';
import {Control} from 'ol/control';
import Style from 'ol/style/Style';
import {focusOn} from '/src/modules/features/featureControl';
import ImageSlider from '/src/modules/imageSlider/imageSlider';
import SimpleBar from 'simplebar';
import {getStammdatenByQuoteLineId} from '/src/modules/api/api';
import {createHTMLElement, sortObjects} from '/src/modules/misc/misc';
import {map, messeId, getQlId, lang, exhibitionConfig} from '/main';
import {getCenter as getExtentCenter, getHeight as getExtentHeight, getWidth as getExtentWidth} from 'ol/extent';
import {replaceTextPlaceholder} from '/src/modules/language/language';
import VectorLayer from 'ol/layer/Vector';

export class ContextControl extends Control {
  constructor(opt_options) {
    const options = opt_options || {};

    const contextBox = createHTMLElement('div', 'ol-control ol-unselectable contextBox', 'contextBox');
    contextBox.style.height = (document.documentElement.clientHeight - 75) + 'px';
    contextBox.style.maxHeight = (document.documentElement.clientHeight - 75) + 'px';

    const contextContentHead = createHTMLElement('div', 'ol-unselectable context-content-head', 'context-content-head');
    const contextContentHeadCollapse = createHTMLElement('div', 'context-chevron', 'contextChevron', '<i class="fas fa-caret-left" id="contextSymbol"></i>');
    const contextHeadLabel = createHTMLElement('span', 'context-label', 'contextLabel');

    contextContentHead.appendChild(contextHeadLabel);
    contextContentHead.appendChild(contextContentHeadCollapse);

    const contextContent = createHTMLElement('div', 'context-content', 'contextContent');
    contextContent.style.height = (document.documentElement.clientHeight - 124) + 'px';
    contextContent.style.maxHeight = (document.documentElement.clientHeight - 124) + 'px';

    contextBox.appendChild(contextContentHead);
    contextBox.appendChild(contextContent);

    super({
      element: contextBox,
      target: options.target,
    });

    window.addEventListener('resize', this.resizeOnWindowChange.bind(this), {passive: true});
    contextContentHeadCollapse.addEventListener('click', this.toggleContext.bind(this), {passive: true});
    contextContentHeadCollapse.addEventListener('touchstart', this.toggleContext.bind(this), {passive: true});
  }

  resizeOnWindowChange() {
    const contextBox = document.getElementById('contextBox');
    const contextContent = document.getElementById('contextContent');
    contextBox.style.height = (document.documentElement.clientHeight - 75) + 'px';
    contextBox.style.maxHeight = (document.documentElement.clientHeight - 75) + 'px';

    if (typeof document.getElementById('moreDetails') !== 'undefined') {
      contextContent.style.height = (document.documentElement.clientHeight - 183) + 'px';
      contextContent.style.maxHeight = (document.documentElement.clientHeight - 183) + 'px';
    } else {
      contextContent.style.height = (document.documentElement.clientHeight - 124) + 'px';
      contextContent.style.maxHeight = (document.documentElement.clientHeight - 124) + 'px';
    }
  }

  toggleContext() {
    const contextSymbol = document.getElementById('contextSymbol');
    const contextContentHead = document.getElementById('context-content-head');
    const contextBox = document.getElementById('contextBox');
    const contextContentHeadCollapse = document.getElementById('contextChevron');

    if (contextContentHead.classList.contains('headCollapsed') !== true) {
      contextBox.style.transform = '';
      contextContentHead.classList.add('headCollapsed');
      contextContentHeadCollapse.classList.add('chevronCollapsed');
      contextSymbol.style.transform = 'rotate(180deg)';
      contextBox.style.overflow = 'visible';
    } else {
      contextContentHead.classList.remove('headCollapsed');
      contextContentHeadCollapse.classList.remove('chevronCollapsed');
      contextBox.style.transform = 'translateX(0)';
      contextSymbol.style.transform = 'rotate(0)';
      setTimeout(() => {
        contextBox.style.overflow = '';
      }, 300);
    }
  }
}

export function showContext(feature) {
  let contextBox = document.getElementById('contextBox');
  let contextContentHead = document.getElementById('context-content-head');
  let contextChevron = document.getElementById('contextChevron');
  let contextSymbol = document.getElementById('contextSymbol');
  let contextContent = document.getElementById('contextContent');

  /**
   * Clear the context content
   */
  while (contextContent.firstChild) {
    contextContent.removeChild(contextContent.firstChild);
  }

  if (contextContent.hasAttribute('data-simplebar')) {
    contextContent.removeAttribute('data-simplebar');
  }

  if (
    typeof feature.get('type') !== 'undefined'
    && (
      feature.get('type') === 'Halle'
      || feature.get('type') === 'Hof'
      || feature.get('type') === 'Eingang'
      || feature.get('type') === 'Freigelände'
      || feature.get('type') === 'Atrium'
      || feature.get('type') === 'ICM'
    )
  ) {
    let hallContext = feature.get('contextObject');
    if (typeof hallContext !== 'undefined') {
      if (typeof hallContext.icon !== 'undefined') {
        let featureName = replaceTextPlaceholder(feature.get('name'));


        let contextLabel = '';

        if (feature.get('type') === 'Halle') {
          contextLabel = lang['jsonHall'] + ' ' + featureName;
        } else if (feature.get('type') === 'Eingang') {
          contextLabel = lang['jsonEntry'] + ' ' + featureName;
        } else if (feature.get('type') === 'Freigelände') {
          contextLabel = lang['OUTDOORSPACE'] + ' ' + featureName;
        } else if (feature.get('type') === 'Hof') {
          contextLabel = lang['YARD'] + ' ' + featureName;
        } else {
          contextLabel = featureName;
        }

        setContextLabel(contextLabel, hallContext.icon);
      } else {
        console.log('Error: Either feature name or feature context icon is not given');
      }

      if (hallContext['images'].length > 0) {}
    }

    setContextContent(feature);

    if (contextContentHead.classList.contains('headCollapsed')) {
      contextContentHead.classList.remove('headCollapsed');
      contextBox.style.overflow = '';

      if (contextChevron.classList.contains('chevronCollapsed')) {
        contextChevron.classList.remove('chevronCollapsed');
        contextSymbol.style.transform = 'rotate(0deg)';
      }
    }

    contextBox.style.transform = 'translateX(0)';
  } else if (typeof feature.get('type') !== 'undefined' && feature.get('type') === 'Stand') {
    let featureMainExhibitor = typeof feature.get('mainExhibitor') !== 'undefined' ? feature.get('mainExhibitor') : null;
    let featureNumber = typeof feature.get('number') !== 'undefined' ? feature.get('number') : null;

    if (featureNumber !== null) {
      setContextLabel(lang['contextBooth'] + ' ' + featureNumber, 'far fa-square');
    } else {
      if (typeof featureMainExhibitor !== 'undefined') {
        setContextLabel(featureMainExhibitor[0]['name'], null);
      }
    }

    setContextContent(feature);

    if (contextContentHead.classList.contains('headCollapsed')) {
      contextContentHead.classList.remove('headCollapsed');
      contextBox.style.overflow = '';

      if (contextChevron.classList.contains('chevronCollapsed')) {
        contextChevron.classList.remove('chevronCollapsed');
        contextSymbol.style.transform = 'rotate(0deg)';
      }
    }

    contextBox.style.transform = 'translateX(0)';
  }
}

export function terminateContext() {
  let context = document.getElementById('contextBox');

  context.style.transform = '';
}

function setContextLabel(text, icon) {
  let contextLabel = document.getElementById('contextLabel');

  while (contextLabel.firstChild) {
    contextLabel.removeChild(contextLabel.firstChild);
  }

  if (icon !== null) {
    if (icon.search('&#') > -1) {
      contextLabel.innerHTML = '<i class="material-icons">' + icon + '</i> ' + text;
    } else {
      contextLabel.innerHTML = '<i class="' + icon + '"></i> ' + text;
    }
  } else {
    contextLabel.innerHTML = text;
  }
}

function setContextContent(feature) {
  let contextContent = document.getElementById('contextContent');

  // Add a loader
  let loader = document.createElement('div');
  loader.className = 'loader';
  loader.innerHTML = lang['contextLoadingData'];

  let floatBarsG = document.createElement('div');
  floatBarsG.id = 'floatBarsG';

  for (let i = 1; i < 9; i++) {
    let floatBarG = document.createElement('div');
    floatBarG.id = 'floatBarsG_' + i;
    floatBarG.className = 'floatBarsG';

    floatBarsG.appendChild(floatBarG);
  }

  loader.appendChild(floatBarsG);

  contextContent.appendChild(loader);

  if (
    feature.get('type') === 'Halle'
    || feature.get('type') === 'Hof'
    || feature.get('type') === 'Eingang'
    || feature.get('type') === 'Freigelände'
    || feature.get('type') === 'Atrium'
    || feature.get('type') === 'ICM'
  ) {
    let contentArray = [];

    if (typeof feature.get('contextObject')['images'] !== 'undefined' && feature.get('contextObject')['images'].length > 0) {
      let contextObjectImages = feature.get('contextObject')['images'];
      for (let image of contextObjectImages) {
        contentArray.push({
          'type': 'image',
          'url': image['url'],
          'position': image['position'],
        });
      }
    }

    if (typeof feature.get('contextObject')['videos'] !== 'undefined' && feature.get('contextObject')['videos'].length > 0) {
      let contextObjectVideos = feature.get('contextObject')['videos'];
      for (let video of contextObjectVideos) {
        contentArray.push({
          'type': 'video',
          'url': video['url'],
          'position': video['position'],
        });
      }
    }

    if (contentArray.length > 0) {
      contentArray.sort(function(a, b) {
        return sortObjects(a['position'], b['position']);
      });
    }

    let contextContentImagery = document.createElement('div');
    contextContentImagery.className = 'imagery';
    contextContentImagery.appendChild(ImageSlider(contentArray));
    contextContent.appendChild(contextContentImagery);

    if (typeof feature.get('contextObject')['entries'] !== 'undefined' && feature.get('contextObject')['entries'].length > 0) {
      let contextObjectEntries = feature.get('contextObject')['entries'];
      for (let contextEntry of contextObjectEntries) {
        let entry = document.createElement('div');
        entry.className = 'entry';

        if (contextEntry['icon'] !== null) {
          if (contextEntry['icon'].search('&#') > -1) {
            entry.innerHTML = '<i class="material-icons miIcon">' + contextEntry['icon'] + '</i>';
          } else {
            entry.innerHTML = '<i class="' + contextEntry['icon'] + ' faIcon"></i>';
          }
        }

        if (contextEntry['type'] === 'switch') {
          if (typeof contextEntry['switchable'] !== 'undefined' && contextEntry['switchable'] === true) {
            entry.innerHTML += '<label for="' + contextEntry['identifier'] + feature.get('name') + '">' + contextEntry['name_' + lang['id']] + '</label>';

            let switchLabel = document.createElement('label');
            switchLabel.className = 'switch';

            let switchInput = document.createElement('input');
            switchInput.type = 'checkbox';
            switchInput.id = contextEntry['identifier'] + feature.get('name');

            if (typeof contextEntry['switched'] !== 'undefined' && contextEntry['switched'] === true) {
              map.getLayers().forEach((layer) => {
                if (layer.get('title') === 'Hallen') {
                  layer.getSource().getFeatures().forEach((layerFeature) => {
                    if (typeof layerFeature.get('identifier') !== 'undefined' && layerFeature.get('identifier') === switchInput.id) {
                      layerFeature.setStyle(null);
                    }
                  });
                }
              });
              switchInput.checked = true;
            }

            let roundSlider = document.createElement('span');
            roundSlider.className = 'slider round';

            switchLabel.appendChild(switchInput);
            switchLabel.appendChild(roundSlider);

            entry.appendChild(switchLabel);

            entry.addEventListener('click', () => {
              if (switchInput.checked === false) {
                map.getLayers().forEach((layer) => {
                  if (layer.get('title') === 'Hallen') {
                    layer.getSource().getFeatures().forEach((layerFeature) => {
                      if (typeof layerFeature.get('identifier') !== 'undefined' && layerFeature.get('identifier') === switchInput.id) {
                        layerFeature.setStyle(null);
                      }
                    });
                  }
                });
                switchInput.checked = true;
                contextEntry['switched'] = true;
              } else {
                map.getLayers().forEach((layer) => {
                  if (layer.get('title') === 'Hallen') {
                    layer.getSource().getFeatures().forEach((layerFeature) => {
                      if (typeof layerFeature.get('identifier') !== 'undefined' && layerFeature.get('identifier') === switchInput.id) {
                        layerFeature.setStyle(new Style());
                      }
                    });
                  }
                });
                switchInput.checked = false;
                contextEntry['switched'] = false;
              }
            }, {passive: true});
          }
        } else if (contextEntry.type === 'menu') {
          entry.innerHTML += '<label for="' + contextEntry['identifier'] + feature.get('name') + 'Sub">' + contextEntry['name_' + lang['id']] + '</label>';

          let entryOpenButton = document.createElement('div');
          entryOpenButton.className = 'openButton';
          entryOpenButton.id = contextEntry['identifier'] + feature.get('name') + 'Sub';
          entryOpenButton.innerHTML = '<i class="fas fa-chevron-right"></i>';

          entry.appendChild(entryOpenButton);
        } else if (contextEntry['type'] === 'link') {
          entry.innerHTML += '<label for="' + contextEntry['identifier'] + feature.get('name') + '"><a href="' + contextEntry['url_' + lang['id']] + '" target="_blank" class="contextLink">' + contextEntry['name_' + lang['id']] + ' <i class="fas fa-external-link-alt"></i></a></label>';
        }
        contextContent.appendChild(entry);
      }
    }

    /**
     * Check if hall has a sponsor. If true, create the sponsor box and append it to the context box
     */
    if (typeof feature.get('contextObject')['sponsor'] !== 'undefined' && feature.get('contextObject')['sponsor'] !== null) {
      let contextObjectSponsor = feature.get('contextObject')['sponsor'];
      let sponsorBox = document.createElement('div');
      sponsorBox.className = 'sponsorBox';

      let sponsor = document.createElement('img');
      sponsor.className = 'sponsorImage';
      sponsor.src = contextObjectSponsor['image'];
      sponsor.alt = contextObjectSponsor['name'];

      let link = document.createElement('a');
      link.className = 'sponsorLink';
      link.href = contextObjectSponsor['link'];
      link.target = '_blank';
      link.title = contextObjectSponsor['name'];

      link.appendChild(sponsor);
      sponsorBox.appendChild(link);

      contextContent.appendChild(sponsorBox);
    }
    new SimpleBar(contextContent);
  } else if (feature.get('type') === 'Stand') {
    let featureNumber = typeof feature.get('number') !== 'undefined' ? feature.get('number') : null;
    document.querySelector('.loader').setAttribute('style', 'display: block');

    /**
     * foo
     * @param {string} opportunityType
     * @return {string}
     */
     function getOpportunityTypeTranslation(opportunityType) {
      return '<i class="fas ' + lang['context' + opportunityType.replace(' ', '') + 'Icon'] + '"></i> ' + lang['context' + opportunityType.replace(' ', '')];
    }

    getStammdatenByQuoteLineId(messeId, feature.get('quotelineid')).then((stammdaten) => {
      if (typeof stammdaten !== 'undefined' && stammdaten.length > 0 && stammdaten != 'Error: Data not found') {
        document.querySelector('.loader').removeAttribute('style');
        stammdaten.forEach((exhibitor) => {
          // Skip iteration if exhibitor is a co exhibitor and is not related to the initially called exhibitor
          if (exhibitor['ChildOpportunityType'] === 'Coexhibitor' && exhibitor['QuoteLineID'] !== getQlId) {
            return;
          }
          let contentEntry = document.createElement('div');
          contentEntry.className = 'contentEntry';
          let exhibitorName = document.createElement('div');
          exhibitorName.className = 'exhibitorName';
          exhibitorName.innerHTML = exhibitor['OpportunityAccountName'];

          contentEntry.appendChild(exhibitorName);

          if (featureNumber !== null) {
            let exhibitorType = document.createElement('div');
            exhibitorType.className = 'exhibitorType';
            exhibitorType.innerHTML = getOpportunityTypeTranslation(exhibitor['ChildOpportunityType']);

            contentEntry.appendChild(exhibitorType);

            if (feature.get('quotelineid') === getQlId) {
              if (exhibitor['BillingStreet'] !== null || exhibitor['BillingPostalCode'] !== null || exhibitor['BillingCity'] !== null || exhibitor['BillingCountry'] !== null) {
                let exhibitorAddress = document.createElement('div');
                exhibitorAddress.className = 'exhibitorAddress';
                exhibitorAddress.innerHTML = (exhibitor['BillingStreet'] !== null ? ('<p>' + exhibitor['BillingStreet'] + '</p>') : '') +
                  ((exhibitor['BillingPostalCode'] !== null || exhibitor['BillingCity'] !== null) ? '<p>' : '') +
                  (exhibitor['BillingPostalCode'] !== null ? exhibitor['BillingPostalCode'] : '') + ' ' + (exhibitor['BillingCity'] !== null ? exhibitor['BillingCity'] : '') +
                  ((exhibitor['BillingPostalCode'] !== null || exhibitor['BillingCity'] !== null) ? '</p>' : '') +
                  (exhibitor['BillingCountry'] !== null ? ('<p>' + exhibitor['BillingCountry'] + '</p>') : '');

                contentEntry.appendChild(exhibitorAddress);
              }
            }
          }
          contextContent.appendChild(contentEntry);
        });
      } else {
        document.querySelector('.loader').removeAttribute('style');
        let contentEntry = document.createElement('div');
        contentEntry.className = 'contentEntry';
        let exhibitorName = document.createElement('div');
        exhibitorName.className = 'exhibitorName';
        exhibitorName.innerHTML = feature.get('mainExhibitor')[0]['name'];

        contentEntry.appendChild(exhibitorName);


        contextContent.appendChild(contentEntry);
      }
      let dimensions = document.createElement('div');
      dimensions.className = 'exhibitorDimensions';
      dimensions.innerHTML = lang['contextBoothDimensions'];

      let dimensionsWidth = document.createElement('div');
      dimensionsWidth.className = 'exhibitorDimensionsWidth';
      dimensionsWidth.innerHTML = '<span class="dimensionsTitle">' + lang['contextBoothWidth'] + '</span>';
      dimensionsWidth.innerHTML += typeof feature.get('width') !== 'undefined' && feature.get('width') > 0 ? feature.get('width') + ' m' : 'n/a';

      let dimensionsDepth = document.createElement('div');
      dimensionsDepth.className = 'exhibitorDimensionsDepth';
      dimensionsDepth.innerHTML = '<span class="dimensionsTitle">' + lang['contextBoothDepth'] + '</span>';
      dimensionsDepth.innerHTML += typeof feature.get('depth') !== 'undefined' && feature.get('depth') > 0 ? feature.get('depth') + ' m' : 'n/a';

      let dimensionsArea = document.createElement('div');
      dimensionsArea.className = 'exhibitorDimensionsArea';
      dimensionsArea.innerHTML = '<span class="dimensionsTitle">' + lang['contextBoothArea'] + '</span>';
      dimensionsArea.innerHTML += typeof feature.get('area') !== 'undefined' && feature.get('area') > 0 ? feature.get('area') + ' m²' : 'n/a';

      dimensions.appendChild(dimensionsWidth);
      dimensions.appendChild(dimensionsDepth);
      dimensions.appendChild(dimensionsArea);

      contextContent.appendChild(dimensions);

      if (typeof feature.get('correspondingId') !== 'undefined' && feature.get('correspondingId') !== '') {
        map.getLayers().forEach((layer) => {
          if (layer instanceof VectorLayer) {
            if (layer.getSource().getFeatureById(feature.get('correspondingId')) !== null) {
              let layerFeature = layer.getSource().getFeatureById(feature.get('correspondingId'));

              // <FLAYR-81>
              const id = feature.get('correspondingId');
              const item = exhibitionConfig?.context?.[id];

              if (item?.additionalContextText && item.additionalContextText.length > 0) {
                let additionalContextText = item.additionalContextText;
                let addTextContainer = document.createElement('div');
                addTextContainer.className = 'additionalInformationContainer';

                additionalContextText.forEach((val, key, arr) => {
                  if (typeof exhibitionConfig['additionalText'][val] !== 'undefined' && exhibitionConfig['additionalText'][val] !== '') {
                    let addText = document.createElement('div');
                    addText.className = 'additionalInformation';
                    addText.insertAdjacentHTML('beforeend', exhibitionConfig['additionalText'][val][lang['id']]);

                    if (key < arr.length - 1) {
                      addText.insertAdjacentElement('beforeend', document.createElement('br'));
                      addText.insertAdjacentElement('beforeend', document.createElement('br'));
                    }

                    addTextContainer.appendChild(addText);
                  }

                  contextContent.appendChild(addTextContainer);
                });
              }
              // </FLAYR-81>

              if (typeof layerFeature.get('contextObject') !== 'undefined') {
                let moreDetails = document.createElement('div');
                moreDetails.className = 'moreDetails';
                moreDetails.id = 'moreDetails';

                let moreDetailsLink = document.createElement('a');
                moreDetailsLink.id = 'moreDetailsLink';
                moreDetailsLink.innerHTML = '<i class="fas fa-info-circle"></i> ' + lang['contextMoreDetails'] + ' ' + feature.get('label');
                moreDetailsLink.title = lang['contextMoreDetailsLinkTitle'].replace('{FEATURE}', feature.get('label'));

                contextContent.style.height = (document.documentElement.clientHeight - 183) + 'px';
                contextContent.style.maxHeight = (document.documentElement.clientHeight - 183) + 'px';

                moreDetailsLink.addEventListener('click', () => {
                  if (
                    layerFeature.get('type') === 'Halle'
                    || layerFeature.get('type') === 'Hof'
                    || layerFeature.get('type') === 'Eingang'
                    || layerFeature.get('type') === 'Freigelände'
                    || layerFeature.get('type') === 'Atrium'
                    || layerFeature.get('type') === 'ICM'
                  ) {
                    if (typeof layerFeature.get('contextObject') !== 'undefined') {
                      let featureExtent = layerFeature.getGeometry().getExtent();
                      let extentCenter = getExtentCenter(featureExtent);
                      let rotate;
                      if (typeof exhibitionConfig['core']['rotateOnFocus'] !== 'undefined' && exhibitionConfig['core']['rotateOnFocus'] === false) {
                        rotate = false;
                      } else {
                        rotate = getExtentWidth(featureExtent) < getExtentHeight(featureExtent);
                      }

                      focusOn(extentCenter, rotate, 42, featureExtent, true);
                      showContext(layerFeature);
                    }
                  }
                }, {passive: true});

                moreDetails.appendChild(moreDetailsLink);
                contextContent.appendChild(moreDetails);
              }
            }
          }
        });
      }

      new SimpleBar(contextContent);
    });
  }
}